import { useEffect } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import type { Props } from '../Bm3PageLoadMark.tsx';

const UFOLoadMarkComponent = ({ name }: Props) => {
	useEffect(() => {
		addUFOCustomMark(name);
	}, [name]);

	return null;
};

export const UFOLoadMark = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(UFOLoadMarkComponent);
